<h3 *ngIf="ecashView" class="text-black mb-2 d-lg-block d-none">
  {{ 'payment.history.page.title' | translate }}
</h3>

<div class="card border mt-lg-0">
  <div [ngClass]="{ 'card-body-ecash': ecashView, 'card-body-account': accountView }">
    <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
    <button type="button" class="search-button fw-bold d-block border-0" (click)="search()">Search</button>
  </div>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
></fgb-transaction-list>
